export enum EStageTypes {
  filling,
  success,
  error,
}

export type IFormStages = {
  [key in EStageTypes]: { next: EStageTypes };
};

export const formStages: IFormStages = {
  [EStageTypes.filling]: { next: EStageTypes.success },
  [EStageTypes.success]: { next: EStageTypes.filling },
  [EStageTypes.error]: { next: EStageTypes.filling },
};

export const MODAL_WIDTH = 688;
export const MODAL_MAX_WIDTH = MODAL_WIDTH;
